import {
    Card,
    Bleed,
    Divider,
    InlineStack,
    IndexTable,
    Layout,
    Page,
    SkeletonBodyText,
    SkeletonDisplayText,
    BlockStack,
} from '@shopify/polaris';
import React from 'react';

const Skeleton = () => {
    const rowMarkup = (
        <>
            <IndexTable.Row id="0" key="0" position={0}>
                <IndexTable.Cell>
                    <SkeletonBodyText lines={6} />
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <SkeletonBodyText lines={4} />
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <SkeletonDisplayText size="small" />
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <SkeletonDisplayText size="small" />
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <SkeletonDisplayText size="medium" />
                </IndexTable.Cell>
            </IndexTable.Row>
        </>
    );

    return (
        <Page
            fullWidth
            title=""
            titleMetadata={
                <div className="custom__skeleton--w175">
                    <SkeletonDisplayText size="medium" />
                </div>
            }
            backAction={{ content: '', url: '#' }}
        >
            <Layout>
                <Layout.Section>
                    <BlockStack gap="500">
                        <Card>
                            <BlockStack gap="500">
                                <div className="header__title">
                                    <InlineStack align="space-between">
                                        <SkeletonDisplayText size="small" />
                                        <SkeletonDisplayText size="small" />
                                    </InlineStack>
                                </div>
                                <Bleed marginInline="500">
                                    <Divider />
                                </Bleed>
                                <div className="Custom__Table--Shipment">
                                    <IndexTable
                                        resourceName={{
                                            singular: 'order',
                                            plural: 'orders',
                                        }}
                                        itemCount={2}
                                        headings={[
                                            {
                                                title: (
                                                    <SkeletonDisplayText size="small" />
                                                ),
                                                id: 'title',
                                            },
                                            {
                                                title: (
                                                    <div className="Custom__heading--Skeleton">
                                                        <SkeletonDisplayText size="small" />
                                                    </div>
                                                ),
                                                id: 'product_details',
                                            },
                                            {
                                                title: (
                                                    <SkeletonDisplayText size="small" />
                                                ),
                                                id: 'quantity',
                                            },
                                            {
                                                title: (
                                                    <SkeletonDisplayText size="small" />
                                                ),
                                                id: 'weight',
                                            },
                                            {
                                                title: (
                                                    <SkeletonDisplayText size="small" />
                                                ),
                                                id: 'hazardous',
                                            },
                                        ]}
                                        selectable={false}>
                                        {rowMarkup}
                                    </IndexTable>
                                </div>
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap="1000">
                                <BlockStack gap="600">
                                    <div className="custom__table--heading">
                                        <SkeletonDisplayText size="medium" />
                                    </div>
                                    <Bleed marginInline="500">
                                        <Divider />
                                    </Bleed>
                                    <div className="Custom__Layout--Section">
                                        <Layout>
                                            <Layout.AnnotatedSection
                                                id="package"
                                                title={
                                                    <div className="custom__skeleton--w175">
                                                        <SkeletonDisplayText size="small" />
                                                    </div>
                                                }>
                                                <div className="custom__table--heading">
                                                    <SkeletonDisplayText size="medium" />
                                                </div>
                                            </Layout.AnnotatedSection>
                                        </Layout>
                                    </div>
                                    <div className="Custom__Layout--Section">
                                        <Layout>
                                            <Layout.AnnotatedSection
                                                id="package"
                                                title={
                                                    <div className="custom__skeleton--w145">
                                                        <SkeletonDisplayText size="small" />
                                                    </div>
                                                }>
                                                <div className="custom__table--heading">
                                                    <SkeletonDisplayText size="medium" />
                                                </div>
                                            </Layout.AnnotatedSection>
                                        </Layout>
                                    </div>
                                    <div className="Custom__Layout--Section">
                                        <Layout>
                                            <Layout.AnnotatedSection
                                                id="package"
                                                title={
                                                    <SkeletonDisplayText size="small" />
                                                }>
                                                <div className="custom__table--heading">
                                                    <BlockStack gap="300">
                                                        <SkeletonDisplayText size="medium" />
                                                        <BlockStack gap="500">
                                                            <InlineStack align="space-between">
                                                                <div className="Custom__text--Skeleton">
                                                                    <SkeletonBodyText
                                                                        lines={
                                                                            1
                                                                        }
                                                                    />
                                                                </div>
                                                                <div className="Custom__text--Skeleton">
                                                                    <SkeletonBodyText
                                                                        lines={
                                                                            1
                                                                        }
                                                                    />
                                                                </div>
                                                            </InlineStack>
                                                            <div className="Custom__text--Skeleton">
                                                                <SkeletonBodyText
                                                                    lines={4}
                                                                />
                                                            </div>
                                                        </BlockStack>
                                                    </BlockStack>
                                                </div>
                                            </Layout.AnnotatedSection>
                                        </Layout>
                                    </div>
                                    <div className="Custom__Layout--Section">
                                        <Layout>
                                            <Layout.AnnotatedSection
                                                id="package"
                                                title={
                                                    <SkeletonDisplayText size="small" />
                                                }>
                                                <div className="custom__table--heading">
                                                    <SkeletonDisplayText size="medium" />
                                                </div>
                                            </Layout.AnnotatedSection>
                                        </Layout>
                                    </div>
                                    <div className="Custom__Layout--Section">
                                        <Layout>
                                            <Layout.AnnotatedSection
                                                id="package"
                                                title={
                                                    <div className="custom__skeleton--w175">
                                                        <SkeletonDisplayText size="small" />
                                                    </div>
                                                }>
                                                <SkeletonDisplayText size="medium" />
                                            </Layout.AnnotatedSection>
                                        </Layout>
                                    </div>
                                    <div className="Custom__Layout--Section">
                                        <Layout>
                                            <Layout.AnnotatedSection
                                                id="package"
                                                title={
                                                    <div className="custom__skeleton--w175">
                                                        <SkeletonDisplayText size="small" />
                                                    </div>
                                                }>
                                                <div className="custom__table--heading">
                                                    <SkeletonDisplayText size="medium" />
                                                </div>
                                            </Layout.AnnotatedSection>
                                        </Layout>
                                    </div>
                                </BlockStack>
                                <InlineStack align="end">
                                    <div className="Custom_Skeleton--button">
                                        <SkeletonDisplayText size="medium" />
                                    </div>
                                </InlineStack>
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                    <BlockStack gap="500">
                        <Card>
                            <BlockStack gap="500">
                                <BlockStack gap="200">
                                    <SkeletonDisplayText />
                                    <div className="Custom__text--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                </BlockStack>
                                <Bleed marginInline="500">
                                    <Divider />
                                </Bleed>
                                <div className="Custom__Paragraph--Skeleton m-auto">
                                    <SkeletonBodyText lines={1} />
                                </div>
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap="600">
                                <SkeletonDisplayText />
                                <Bleed marginInline="500">
                                    <Divider />
                                </Bleed>
                                <BlockStack gap="300">
                                    <div className="Custom__text--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                    <div className="Custom__Paragraph--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                </BlockStack>
                                <BlockStack gap="300">
                                    <div className="Custom__text--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                    <div className="Custom__Paragraph--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                </BlockStack>
                                <BlockStack gap="300">
                                    <div className="Custom__text--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                    <div className="Custom__Paragraph--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                </BlockStack>
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap="600">
                                <SkeletonDisplayText />
                                <Bleed marginInline="500">
                                    <Divider />
                                </Bleed>
                                <BlockStack gap="300">
                                    <SkeletonDisplayText />
                                    <div className="Custom__text--Skeleton">
                                        <SkeletonBodyText lines={4} />
                                    </div>
                                </BlockStack>
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </Layout.Section>
            </Layout>
        </Page>
    );
};

export default Skeleton;
